if ($('body.id-29').length) {
    $(".wrapper.first .contacts").html('');
    $(".wrapper.first .contacts").append($("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"));
    $(".wrapper.first .contacts").append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));

    $(".wrapper.first .contacts  li.mail").append(`<span class="info">${mailInfo}</span>`);
    $(".wrapper.first .contacts li.tel").append(`<span class="info">${telefonInfo}</span>`);

    
}